export default __webpack_public_path__ + "static/media/R870_4.9a1810b0.png";